/*
 * Madison Maison - WCAG 2.2 AA runtime accessibility shims
 * Added 2026-05-22 in response to Velandia demand letter.
 *
 * Each function targets a specific axe-core finding that cannot be
 * fixed in static markup because the offending element is injected
 * by a third-party app or rendered dynamically.
 */
(function () {
  'use strict';

  // Redirect any visitor that lands on a deleted Shogun-built page handle.
  // Shopify Page records were deleted 2026-05-22 but Shogun's client-side
  // router keeps the URLs reachable. Hard redirect to / before Shogun can render.
  var deletedHandles = [
    '/pages/press',
    '/pages/jeweled-loafer',
    '/pages/janetgunnjeweledloafer',
    '/pages/jeweled-chain-loafer',
    '/pages/madisonpress',
    '/pages/design-that-transcends-the-generational-divide',
    '/pages/madison-maison-family'
  ];
  var path = window.location.pathname.replace(/\/+$/, '');
  if (deletedHandles.indexOf(path) !== -1) {
    window.location.replace('/');
    return;
  }


  // F: link-name (90 instances) - Judge.me carousel links have no accessible name
  // because .jdgm-ellipsis CSS hides the inner text from the a11y tree.
  function labelJudgeMeCarousel() {
    document.querySelectorAll('a.jdgm-carousel-item__product').forEach(function (a) {
      if (a.hasAttribute('aria-label')) return;
      var title = a.querySelector('.jdgm-carousel-item__product-title');
      var text = title ? title.textContent.trim() : '';
      if (text) a.setAttribute('aria-label', 'Read reviews for ' + text);
    });
    document.querySelectorAll('a.jdgm-widget-actions-wrapper, a.jdgm-write-rev-link').forEach(function (a) {
      if (a.hasAttribute('aria-label')) return;
      var text = a.textContent.trim();
      if (!text) a.setAttribute('aria-label', 'Write a review');
    });
  }

  // F-09: false aria-expanded on static nav links (MUSE BLOG, ABOUT US, etc).
  // Remove the attribute from any element with aria-expanded but no aria-controls,
  // unless it is genuinely a button/disclosure with a popup target.
  function fixFalseAriaExpanded() {
    document.querySelectorAll('a[aria-expanded]').forEach(function (el) {
      var hasControls = el.hasAttribute('aria-controls') && el.getAttribute('aria-controls').trim().length > 0;
      var hasPopup = el.hasAttribute('aria-haspopup');
      var hasSubmenu = el.querySelector('ul, .submenu, [role="menu"]');
      if (!hasControls && !hasPopup && !hasSubmenu) {
        el.removeAttribute('aria-expanded');
      }
    });
  }

  // F-13: Add to Cart announced as "dropdown dialog, button" because the button
  // is wrapped in an element with role=dialog or has conflicting roles.
  // Clean up: ensure Add to Cart buttons have explicit role=button only.
  function fixAddToCartRoles() {
    document.querySelectorAll('button[name="add"], .product-form__submit, [data-add-to-cart]').forEach(function (btn) {
      if (btn.getAttribute('role') && btn.getAttribute('role') !== 'button') {
        btn.setAttribute('role', 'button');
      }
      // Walk up and remove any role=dialog on non-dialog parents (defensive)
      var p = btn.parentElement;
      var depth = 0;
      while (p && depth < 4) {
        if (p.getAttribute('role') === 'dialog' && !p.matches('[aria-modal], dialog')) {
          p.removeAttribute('role');
        }
        p = p.parentElement; depth++;
      }
    });
  }

  // F-02: on PDP load, focus the product heading (not the social-media footer).
  // Only runs once per page; subsequent runs (via MutationObserver) skip the focus shift.
  var _focusedHeading = false;
  function focusProductHeading() {
    if (_focusedHeading) return;
    if (!document.body.classList.contains('template-product')) return;
    var h1 = document.querySelector('h1.wt-product__name, main h1');
    if (!h1) return;
    if (!h1.hasAttribute('tabindex')) h1.setAttribute('tabindex', '-1');
    try {
      h1.focus({ preventScroll: false });
      _focusedHeading = true;
    } catch (e) { /* no-op */ }
  }

  // F-16: announce page changes via a live region so screen readers know
  // they navigated to a new context (skip-link target).
  function ensureLiveRegion() {
    if (document.getElementById('madison-a11y-live')) return;
    var lr = document.createElement('div');
    lr.id = 'madison-a11y-live';
    lr.setAttribute('aria-live', 'polite');
    lr.setAttribute('aria-atomic', 'true');
    lr.style.cssText = 'position:absolute;left:-9999px;width:1px;height:1px;overflow:hidden';
    document.body.appendChild(lr);
    // Announce page title shortly after load so the navigation is acknowledged.
    setTimeout(function () {
      lr.textContent = document.title;
    }, 600);
  }

  // Run on initial load and on DOM mutations (Judge.me, Klaviyo, etc. load async).
  function runAll() {
    labelJudgeMeCarousel();
    fixFalseAriaExpanded();
    fixAddToCartRoles();
    focusProductHeading();
    ensureLiveRegion();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runAll);
  } else {
    runAll();
  }

  // Re-run on async content insertion (review apps, popups, AJAX'd cards).
  var observer = new MutationObserver(function () {
    // Debounce to avoid thrashing.
    if (window._mmA11yT) clearTimeout(window._mmA11yT);
    window._mmA11yT = setTimeout(runAll, 200);
  });
  if (document.body) {
    observer.observe(document.body, { childList: true, subtree: true });
  } else {
    document.addEventListener('DOMContentLoaded', function () {
      observer.observe(document.body, { childList: true, subtree: true });
    });
  }
})();
